export default __webpack_public_path__ + "static/media/maw-mouse.0ceddac1.png";